import { HELPER_WIDGET_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[HELPER_WIDGET_MODULE_ID]: {
		moduleType: 'misc',
		miscModuleType: 'helperWidgetModule',
	},
}
